import React from 'react';
import { Field, DatePicker, TimePicker, GroupField, View } from '@components';
import styled from 'styled-components';

const FieldDtExecucao = styled(Field)`
  margin-left: 0;
  flex: 1;
`;

export default function Unica() {
  return (
    <View>
      <GroupField>
        <FieldDtExecucao label="Executar em" name="dtExecucao">
          <DatePicker format="DD/MM/YYYY" autoFocus />
        </FieldDtExecucao>
        <Field label="às" name="hrExecucao">
          <TimePicker format="HH:mm:ss" />
        </Field>
      </GroupField>
    </View>
  );
}
